import { expVal } from '@atlassian/jira-feature-experiments';
import { dashboardsDirectoryRoute } from '@atlassian/jira-router-routes-directories-routes/src/dashboardsDirectoryRoute.tsx';

import { L1_MENU_ID } from '../../types.tsx';

// This is part of an intermediate state workaround where links are accounted for;
// we don't expect links to be in the More menu at the end state, at which point this can be removed.
export const getUserNavigationItemLinks = (): Record<string, string> => {
	return expVal('navx-1075-remove-goals-and-projects-fallback-urls', 'isEnabled', false)
		? {
				[L1_MENU_ID.APPS]: '/jira/marketplace/discover?source=apps-menu',
				[L1_MENU_ID.GOALS]: '/jira/your-work?goals',
				[L1_MENU_ID.DASHBOARDS]: dashboardsDirectoryRoute.path,
				[L1_MENU_ID.TEAMS]: '/jira/people/search',
				[L1_MENU_ID.ROADMAPS]: '/jira/polaris/roadmaps',
				[L1_MENU_ID.GLOBAL_APP_ASSETS]: '/jira/assets',
				[L1_MENU_ID.GLOBAL_APP_GOALS]: '',
				[L1_MENU_ID.GLOBAL_APP_PROJECTS]: '',
				[L1_MENU_ID.GLOBAL_APP_CONFLUENCE]: '',
				[L1_MENU_ID.GLOBAL_APP_LOOM]: '',
				[L1_MENU_ID.GLOBAL_APP_OPSGENIE]: '',
			}
		: {
				[L1_MENU_ID.APPS]: '/jira/marketplace/discover?source=apps-menu',
				[L1_MENU_ID.GOALS]: '/jira/your-work?goals',
				[L1_MENU_ID.DASHBOARDS]: dashboardsDirectoryRoute.path,
				[L1_MENU_ID.TEAMS]: '/jira/people/search',
				[L1_MENU_ID.ROADMAPS]: '/jira/polaris/roadmaps',
				[L1_MENU_ID.GLOBAL_APP_ASSETS]: '/jira/assets',
				[L1_MENU_ID.GLOBAL_APP_GOALS]: 'https://home.atlassian.com/goals',
				[L1_MENU_ID.GLOBAL_APP_PROJECTS]: 'https://home.atlassian.com/projects',
				[L1_MENU_ID.GLOBAL_APP_CONFLUENCE]: '',
				[L1_MENU_ID.GLOBAL_APP_LOOM]: '',
				[L1_MENU_ID.GLOBAL_APP_OPSGENIE]: '',
			};
};
